module.exports = __webpack_public_path__ + "static/m_alpha_telegram_art@2x-3d1157cf2b81e1557ec62508be592546.png";